import * as React from "react";
import { Alert } from "reactstrap";
import { TreeListBooleanEditor, TreeList, mapTree, treeToFlat } from '@progress/kendo-react-treelist'
import { AccentButton } from "../controls/AccentButton";
import { accentUtils, from, t } from "../services/HelperService";
import { AccentDialog } from "./AccentDialog";
import { AccentSpinner } from "../controls/AccentSpinner";
import { usePosition } from "../controls/AccentDisplay";
import { queryNoTracking, update } from "../services/DataService";



const query_Job_SelectLinesToInvoiceModel = queryNoTracking("Job_SelectLinesToInvoiceModel");


const processTree = (dataTree, childrenField, processItem) => {
    return mapTree(dataTree, childrenField, (item) => processItem(item));
};


export const SelectLinesToInvoiceDlg = props => {

    const [data, setData] = React.useState(null);
    const [expanded, setExpanded] = React.useState({});
    const [selected, setSelected] = React.useState({});
    const [noLines, setNoLines] = React.useState(false);
    const pos = usePosition("selectLinesToInvoice");

    const onExpandChanged = React.useCallback(e => {

        setExpanded(existing => {
            return { ...existing, [e.dataItem.ID]: !e.value };
        });

    }, [setExpanded])

    const onItemChanged = React.useCallback(e => {


        const items = treeToFlat([e.dataItem], "ID", "Children");

        const newChecked = from(items).select(i => i.ID).toArray().reduce((a, v) => ({ ...a, [v]: e.value }), {});

        setSelected(existing => {
            return { ...existing, ...newChecked };
        });
    }, [setSelected]);


    const onInvoice = React.useCallback(e => {

        const allItems = treeToFlat(data, "ID", "Children");

        props.onClose({
            canceled: false,
            lineFilter: from(allItems)
                .where(i => selected[i.ID] && !accentUtils.isEmpty(i.LineID))
                .select(i => i.LineID)
                .toArray()
        });

    }, [data, selected]);



    React.useEffect(() => {

        query_Job_SelectLinesToInvoiceModel.getFirstOrDefault({ id: props.jobID }).then(model => {

            
            const allExpanded = {};
            const defaultSelection = {};
            const r = model.Tree;

            if (accentUtils.isNull(model.Tree)) {
                setNoLines(true);
            } else {

                setData(processTree([r], "Children", item => {

                    allExpanded[item.ID] = true;

                    if (accentUtils.isEmpty(props.defaultLinefilter)) {
                        defaultSelection[item.ID] = true;
                    } else {
                        if (from(props.defaultLinefilter).any(x => x == item.ID)) {
                            defaultSelection[item.ID] = true;
                        }
                    }

                    

                    return { ...item, expanded: true, editing: true, Stage: t(item.Stage), Dispatch: t(item.Dispatch) };
                }));



                setSelected(defaultSelection);
                setExpanded(allExpanded);
            }

            
        })


    }, []);


    const hasSelection = from(Object.values(selected)).any(s => s === true);

    let qty = 0;
    const treeData = processTree(data ?? [], "Children", item => {

        const itemSelected = selected[item.ID] ?? false;

        const isLineItem = (item.Children?.length ?? 0) === 0;

        if (isLineItem && itemSelected) {
            qty += (item.Qty ?? 0);
        }


        return { ...item, expanded: expanded[item.ID] ?? false, selected: itemSelected };
    });



    const height = pos.toScreenHeight - 50;

    return <AccentDialog
        fullscreen
        headerContent={t("application_strings.application.dialogs.selectLinesToInvoice.title")}
        onClose={props.onClose}
        actionsContent={[<AccentButton key="1" disabled={!hasSelection} tagName="save" onClick={onInvoice}>{t("application_strings.application.buttons.invoice")}</AccentButton>]}
    >
        {noLines && <Alert color="danger">{t("application_strings.application.dialogs.selectLinesToInvoice.noLines")}</Alert>}
        {!noLines && accentUtils.isNull(data) && <AccentSpinner />}
        {!noLines && !accentUtils.isNull(data) &&

            <div id="selectLinesToInvoice">
                <TreeList
                    data={treeData}
                    style={{
                        height: `${height}px`,
                        overflow: "auto",
                    }}
                    editField="editing"
                    expandField="expanded"
                    subItemsField="Children"
                    validationField="validation"
                    columns={columns}
                    onExpandChange={onExpandChanged}
                    onItemChange={onItemChanged} />
                <div className="float-right"><label>{t("application_strings.application.dialogs.selectLinesToInvoice.selectedQty")}</label>:<span style={{ laddingLeft: "20px" }}>{qty}</span></div>
            </div>
        }
    </AccentDialog>

};



const columns = [
    {
        field: "selected",
        title: " ",
        expandable: true,
        editCell: TreeListBooleanEditor,
        locked: true,
        width: 30,
    },
    {
        field: "Item",
        title: "Item",
        width: 250,
        expandable: true,

    },
    {
        field: "Qty",
        title: "Qty",
        width: 70,
        expandable: false,
    },
    {
        field: "Stage",
        title: "Stage",
        width: 250,
        expandable: false,
    },
    {
        field: "Location",
        title: "Location",
        width: 250,
        expandable: false,
    },
    {
        field: "Dispatch",
        title: "Dispatch",
        width: 250,
        expandable: false,
    },
    {
        field: "DisplayOption1",
        title: "Option 1",
        width: 250,
        expandable: false,
    },
    {
        field: "DisplayOption2",
        title: "Option 2",
        width: 250,
        expandable: false,
    },
    {
        field: "DisplayOption3",
        title: "Option 3",
        width: 250,
        expandable: false,
    }

];